<!--
 * @Author: your name
 * @Date: 2021-04-14 15:11:36
 * @LastEditTime: 2021-07-09 14:06:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\auction\Index.vue
-->
<template>
  <div class="page">
    <PageTitle :title="title"
               :routes="routes"></PageTitle>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Brand',
  components: {
    PageTitle
  },
  computed: {
    title () {
      let name = '限时秒杀管理'
      if (this.$route.name === 'SpikeDetail') {
        if (this.$route.query.id) {
          name = '秒杀详情'
        } else {
          name = '添加秒杀商品'
        }
      }
      return name
    },
    ...mapState({
      routes: 'route'
    })
  }
}
</script>